<template>
  <div>
    <div class="columns">
      <div class="column is-8 is-offset-2">
        <div class="notification is-info is-size-4 has-text-centered u-p2 has-text-light has-text-weight-semibold" role="status" aria-live="polite">
          <b-icon icon="sad-cry" size="is-large"></b-icon>
          <br />{{ $t('product.no-offer') }}
        </div>
      </div>
    </div>

    <OfferBlock :title="$t('general.further-offers')" :offers="furtherOffers" />

    <h3 class="title is-size-3 has-text-centered is-size-4-mobile">{{ $t('general.themes') }}</h3>
    <div class="columns is-centered">
      <div class="column is-10-desktop is-8-widescreen">
        <div class="buttons is-justify-content-center">
          <b-button
            tag="router-link"
            v-for="item in menu.themes"
            :key="item.key"
            :to="{
              name: 'search-by-theme',
              params: {
                id: item.key,
                name: $options.filters.removeSpecialChars(item.value),
              },
            }"
            type="is-dark"
          >
            {{ item.value }}
          </b-button>
        </div>
      </div>
    </div>

    <p class="has-text-centered has-text-weight-bold mt-5">
      {{ $whitelabel.firstNameBasis ? $t('product.more-offer-wait-fnb') : $t('product.more-offer-wait') }}
    </p>
    <div class="has-text-centered mt-3">
      <b-button tag="router-link" to="/" type="is-dark">
        {{ $t('product.go-to-all-offers') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import store from '@/modules/hoteldisplay/_store'

const OfferBlock = () => import(/* webpackPrefetch: true , webpackChunkName: "offerblock" */ '@/components/OfferBlock')

export default {
  name: 'NoOffer',
  props: {},
  components: {
    OfferBlock,
  },
  created() {
    const STORE_KEY = '$_hotel'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }
  },
  computed: {
    ...mapGetters({
      furtherOffers: '$_hotel/furtherOffers',
      menu: 'menu',
    }),
  },
  async mounted() {
    this.$store.dispatch('$_hotel/getFurtherOffers')
  },
}
</script>

<style lang="scss"></style>
